import input from './input.js';
// returns a binder for textarea element
export default function progress() {
  return input();
}